import Fa from 'admin/components/atoms/FontAwesome';
import { COLOR } from 'admin/constants/styles';
import React from 'react';
import styled from 'styled-components';

type Message = { text: string; isError?: boolean };

type Props = {
  messages?: Message[];
  className?: string;
};

const Message = styled.div`
  background: ${COLOR.success};
`;

const Error = styled.div`
  background: ${COLOR.alert};
  border-radius: 5px;
`;

const ErrorMessage = styled.span`
  display: inline-block;
  margin: 0 10px;
  color: #9d0208;
`;

const ApiResults = ({ messages, className = '' }: Props) => {
  if (messages && messages.length > 0) {
    return (
      <div className={className}>
        {messages.map((m) =>
          m.isError ? (
            <Error key="api-results-error">
              <Fa icon="exclamation-circle" style={{ color: '#9d0208' }} />
              <ErrorMessage>{m.text}</ErrorMessage>
            </Error>
          ) : (
            <Message key="api-results-success">{m.text}</Message>
          )
        )}
      </div>
    );
  }
  return null;
};

export default styled(ApiResults)`
  div {
    padding: 15px;
    margin-bottom: 5px;
  }
`;
